// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21dMX","col":"styles_col__1gzxa"};